import { useActiveAuthProvider, useWarnAboutChange } from '@refinedev/core';
import { useNavigate } from 'react-router-dom';
import { syncSettingsWithBackend } from 'store/SettingsStore';
import { useCurrentSiteStore } from 'store/SiteStore';
import { useCurrentUserStore } from 'store/UserStore';

export const useLogout = () => {
  const authProvider = useActiveAuthProvider();
  const { warnWhen, setWarnWhen } = useWarnAboutChange();
  const { clearCurrentUser } = useCurrentUserStore();
  const { clearCurrentSite } = useCurrentSiteStore();
  const navigate = useNavigate();

  const handleLogout = async () => {
    if (warnWhen) {
      const confirm = window.confirm(
        'You have unsaved changes. Are you sure you want to logout?'
      );
      if (!confirm) {
        return;
      }
      setWarnWhen(false);
    }
    await syncSettingsWithBackend();
    await authProvider.logout({ redirectTo: '/login' });
    clearCurrentUser();
    clearCurrentSite();
    sessionStorage.clear();

    navigate('/login');
  };
  return handleLogout;
};
